import React from 'react';
import { typedAs } from '@odin-labs/components';
import { CodeInputFormField } from 'components/codeInput';
import { CodeInputFormFieldProps } from 'components/codeInput/types';
import {
  FormInputTypes,
  GridColSpan,
  TypedFormInputs,
  UseFormMethods,
  UseInputs,
} from 'components/form';
import { PIN_LENGTH, validatePinPolicy } from './utils';

export type EnterPinFormData = { pin: string };

const getFormInputs = (): TypedFormInputs<EnterPinFormData> => {
  return {
    pin: {
      element: FormInputTypes.CustomInput,
      elementProps: {
        customInput: CodeInputFormField,
        ...typedAs<Omit<CodeInputFormFieldProps, 'name'>>({
          mask: true,
        }),
      },
      layout: GridColSpan.SpanFull,
      validation: {
        validate: (v: string): true | string => {
          return validatePinPolicy(v) ?? true;
        },
      },
    },
  };
};

export const getFormInputsHook =
  (args: { submitForm: () => void }): UseInputs<EnterPinFormData> =>
  (
    form: UseFormMethods<EnterPinFormData>,
  ): TypedFormInputs<EnterPinFormData> => {
    const { submitForm } = args;
    const { watch } = form;
    const pin = watch('pin');

    React.useEffect(() => {
      if (pin?.length === PIN_LENGTH) {
        submitForm();
      }
    }, [pin]);

    return React.useMemo(() => getFormInputs(), []);
  };

export const getFormDefaultValues = (): EnterPinFormData => {
  return {
    pin: '',
  };
};
